/* global axios */
import ApiClient from './ApiClient';

class CSATReportsAPI extends ApiClient {
  constructor() {
    super('csat_survey_responses', { accountScoped: true });
  }

  get({ page, from, to, user_ids, inbox_id, team_id, rating, workflow } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        since: from,
        until: to,
        sort: '-created_at',
        workflow,
        inbox_id,
        rating,
      },
    });
  }

  download({ from, to, user_ids, inbox_id, team_id, rating, workflow, language } = {}) {
    let since = from + 3600 ;
    return axios.get(`${this.url}/download`, {
      params: {
        since: since,
        until: to,
        sort: '-created_at',
        user_ids,
        inbox_id,
        team_id,
        rating,
        workflow,
        language
      },
    });
  }

  getMetrics({ from, to, user_ids, inbox_id, team_id, rating, workflow } = {}) {
    // no ratings for metrics
    return axios.get(`${this.url}/metrics`, {
      params: { since: from, until: to, workflow, inbox_id, rating },
    });
  }
}

export default new CSATReportsAPI();
